import React, { HTMLAttributes } from 'react'
import P from '../../../elements/Typo/P'

interface Props extends HTMLAttributes<HTMLDivElement> {}

const ColumnHeading: React.FC<Props> = ({ children, className = '' }) => {
    return (
        <div className="flex items-center mt-[0.100rem]">
            <div className="relative h-0 w-0">
                <div className="absolute -left-[0.833rem] top-[0.1rem] -translate-y-[50%] h-[2.208rem] w-[0.5rem] bg-primary rounded-e-md"></div>
            </div>
            <P className={`!m-0 !leading-6 text-[1.091rem] font-semibold ${className}`}>{children}</P>
        </div>
    )
}

export default ColumnHeading
